<template>
  <div class="inner-box">
    <div slot="content">
      <el-form size="medium" @submit.prevent="save">
        <div class="content-name">
          <h2 class="dp-ib">{{ routeName }}</h2>
          <el-form-item label-width="0px" style="float: right;">
            <el-button type="primary" icon="el-icon-search" @click="goOpen">
              {{ this.$i18n.messages[this.$store.state.locale].search }}
            </el-button>
          </el-form-item>
          <el-form-item label-width="0px" style="float:right;">
            <el-button type="danger" icon="el-icon-lock" @click="goClose">
              마감
            </el-button>
          </el-form-item>
        </div>
      </el-form>

      <div class="search-form">
        <el-form size="mini" label-width="80px">
          <el-row style="margin-bottom: 0px;">
            <el-col :span="14">
              <el-form-item label="정산년월">
                <el-col :span="12">
                  <el-select v-model="form.years">
                    <el-option
                        v-for="item in combos['years']"
                        :key="item.value"
                        :value="item.key"
                        :label="item.value">
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="12">
                  <el-select v-model="form.months">
                  <el-option
                      v-for="item in combos['months']"
                      :key="item.value"
                      :value="item.key"
                      :label="item.value">
                  </el-option>
                </el-select>
              </el-col>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="구분">
                <el-select v-model="form.closingType" @change="onClosingTypeChange">
                  <el-option
                      v-for="item in combos['closingType']"
                      :key="item.value"
                      :value="item.key"
                      :label="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-divider></el-divider>
          <el-row style="margin-bottom: 0px;">
            <el-col :span="4" v-if="modelSearchShow">
              <el-form-item label="제조사">
                <el-select v-model="form.maker" >
                  <el-option value='' label="전체">전체</el-option>
                  <el-option
                      v-for="item in combos['maker']"
                      :key="item.value"
                      :value="item.key"
                      :label="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="modelSearchShow ? 8 : 10">
              <el-form-item label="제품군" label-width="100px">
                <el-select v-model="form.modelGroup" @change="onModelGroupChange" style="width: 50%;">
                  <el-option value='' label="전체">전체</el-option>
                  <el-option
                      v-for="item in combos['modelGroup']"
                      :key="item.key"
                      :value="item.key"
                      :label="item.value">
                  </el-option>
                </el-select>
                <el-select v-model="form.subModelGroup" style="width: 50%;">
                  <el-option value='' label="전체">전체</el-option>
                  <el-option
                      v-for="item in combos['subModelGroup']"
                      :key="item.key"
                      :value="item.key"
                      :label="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="modelSearchShow ? 6 : 8">
              <el-form-item label="대표모델">
                <el-input type="text" v-model="form.standardModelNm" @keyup.native.enter="goOpen"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6" v-if="modelSearchShow">
              <el-form-item label="모델">
                <el-input type="text" v-model="form.modelCd" @keyup.native.enter="goOpen"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="margin-bottom: 0px;">
            <el-col :span="10">
              <el-form-item label="지역/센터" label-width="100px">
                <el-select v-model="form.asAgentId" @change="onAsAgentIdChange" style="width: 50%;">
                  <el-option value='' label="전체">전체</el-option>
                  <el-option
                      v-for="item in combos['asAgentId']"
                      :key="item.key"
                      :value="item.key"
                      :label="item.value">
                  </el-option>
                </el-select>
                <el-select v-model="form.subAsAgentId" style="width: 50%;">
                  <el-option value='' label="전체">전체</el-option>
                  <el-option
                      v-for="item in combos['subAsAgentId']"
                      :key="item.key"
                      :value="item.key"
                      :label="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8" v-if="itemSearchShow">
              <el-form-item label="자재코드">
                <el-input type="text" v-model="form.itemCd" @keyup.native.enter="goOpen"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>

    <div class="table-area">
      <div class="table-b">
        <div class="table-header">
          <div class="grid-tbl-box">
            <ag-grid-vue
                ref="grid"
                :key="columnDefs.length"
                :style="gridStyle"
                class="ag-theme-alpine"
                :column-defs="columnDefs"
                :grid-options="mainGridOptions"
                :row-data="data"
                :default-col-def="defaultColDef"
                :framework-components="frameworkComponent"
                :statusBar="statusBar"
                :enableRangeSelection="true"
                @grid-ready="onReadyMain"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mixin from "@/mixin/lucoms";
import DatepickerCellRenderer from "@/components/agGrid/datepicker-cell-renderer";
import MaskEditCellRenderer from "@/components/agGrid/maskedit-cell-renderer";
import SelectCellRenderer from "@/components/agGrid/select-cell-renderer";
import CheckboxCellRenderer from "@/components/agGrid/checkbox-cell-renderer";
import RadioCellRenderer from "@/components/agGrid/radio-cell-renderer";
import NumberInputCellRender from "@/components/agGrid/numberinput-cell-renderer";
import InputCellRender from "@/components/agGrid/input-cell-renderer";
import ButtonCellRenderer from "@/components/agGrid/button-cell-renderer";

function _url(...args) {
  args = args.map(x =>
      String(x || "")
          .trim()
          .replace(/^\/*|\/*$/g, "")
  );
  return args.filter(x => x).join("/");
}

export default {
  mixins: [mixin],
  props: {
  },
  data() {
    return {
      data: [],
      form: {
        companyId : '',
        years : this.$moment().format('YYYY'),
        months : this.$moment().format('MM'),
        yyMm : '',
        closingType : '280',         // 구분
        maker : '',                    // 제조사
        modelGroup : '',               // 제품군
        subModelGroup : '',            // 제품군Sub
        standardModelNm : '',          // 대표모델
        modelCd : '',                  // 모델
        asAgentId : '',                // 지역/센터
        subAsAgentId : '',             // 지역/센터(sub)
        catId : '',
        itemCd : '',                   // 자재코드
        sortType :  '',
        page : 1,
        totalPage : 99999,
        curPage : 0,
        totalCount : 99999,
        processTime : ''
      },
      combos: {
        'years' : [],
        'months' : [],
        'closingType' : [],
        'maker' : [],
        'modelGroup' : [],
        'subModelGroup' : [],
        'asAgentId' : [],
        'subAsAgentId' : [],
      },
      // AG-GRID OPTION [START]
      gridStyle : 'padding-top: 20px; width: 100%;height: 650px; min-height:100px;',
      defaultColDef: {
          resizable: true
        , filter:true
        , sortable: true
      },
      mainGridApi: null,
      mainColumnApi: null,
      mainGridOptions: {
        enableColResize: true,
        enableFilter: true,
        animateRows: false,
        enableSorting: true,
      },
      columnDefs: [],
      frameworkComponent : {
        datePicker: DatepickerCellRenderer,
        maskEdit: MaskEditCellRenderer,
        select: SelectCellRenderer,
        checkBox: CheckboxCellRenderer,
        radio: RadioCellRenderer,
        numberInput: NumberInputCellRender,
        input: InputCellRender,
        button: ButtonCellRenderer
      },
      statusBar: null,
      subModelGroupShow: false,
      subAsAgentIdShow : false,
      modelSearchShow : true,
      itemSearchShow : false,
    }
  },
  methods: {
    onReadyMain() {
      this.mainGridApi = this.mainGridOptions.api;
      this.mainColumnApi = this.mainGridOptions.columnApi;

      this.init();
    },
    createMainColumnDefs() {
      const that = this
      this.columnDefs = [];

      // 280 : 제품, 281 : 자재
      if(parseInt(that.form.closingType) === 280) {
        this.columnDefs = [
          {
            headerName:'No',
            field:'no',
            width:80,
            cellStyle:{textAlign: 'center'},
            valueFormatter: function(params) {
              return params.node.rowIndex+1;
            }
          },
          {headerName:'센터명', field:'asAgentNm', width:190, cellStyle : {textAlign: 'left'}},
          {headerName:'제조사', field:'makerNm', width:190, cellStyle : {textAlign: 'center'}},
          {headerName:'제품군', field:'modelGroupNm', width:190},
          {headerName:'대표모델', field:'standardModelNm', width:190},
          {headerName:'모델명', field:'modelNm', width:190},
          {headerName:'전월', field:'preGoodQty', width:120, cellStyle:{textAlign: 'right'},
            valueFormatter: (params) => {
              return that.getNumberFormat(params.value);
            }},
          {headerName:'입고', field:'inGoodQty', width:120, cellStyle:{textAlign: 'right'},
            valueFormatter: (params) => {
              return that.getNumberFormat(params.value);
            }},
          {headerName:'출고', field:'outGoodQty', width:120, cellStyle:{textAlign: 'right'},
            valueFormatter: (params) => {
              return that.getNumberFormat(params.value);
            }},
          {headerName:'당월', field:'invtGoodQty', width:120, cellStyle:{textAlign: 'right'},
            valueFormatter: (params) => {
              return that.getNumberFormat(params.value);
            }}
        ];
      } else {
        this.columnDefs = [
          {
            headerName:'No',
            field:'no',
            width:80,
            cellStyle:{textAlign: 'center'},
            valueFormatter: function(params) {
              return params.node.rowIndex+1;
            }
          },
          {headerName:'센터명', field:'asAgentNm', width:190, cellStyle : {textAlign: 'left'}},
          {headerName:'제품군', field:'itemGroupNm', width:190},
          {headerName:'대표모델', field:'useModelNm', width:190},
          {headerName:'자재코드', field:'itemCd', width:190},
          {headerName:'자재명', field:'itemNm', width:190},
          {
            headerName: '양품',
            children: [
              {headerName:'전월', field:'preGoodQty', width:120, cellStyle:{textAlign: 'right'},
                valueFormatter: (params) => {
                  return that.getNumberFormat(params.value);
                }},
              {headerName:'입고', field:'inGoodQty', width:120, cellStyle:{textAlign: 'right'},
                valueFormatter: (params) => {
                  return that.getNumberFormat(params.value);
                }},
              {headerName:'출고', field:'outGoodQty', width:120, cellStyle:{textAlign: 'right'},
                valueFormatter: (params) => {
                  return that.getNumberFormat(params.value);
                }},
              {headerName:'출고중', field:'outingGoodQty', width:120, cellStyle:{textAlign: 'right'},
                valueFormatter: (params) => {
                  return that.getNumberFormat(params.value);
                }},
              {headerName:'당월', field:'invtGoodQty', width:120, cellStyle:{textAlign: 'right'},
                valueFormatter: (params) => {
                  return that.getNumberFormat(params.value);
                }}
            ]
          },
          {
            headerName: '불량',
            children: [
              {headerName:'전월', field:'preBadQty', width:120, cellStyle:{textAlign: 'right'},
                valueFormatter: (params) => {
                  return that.getNumberFormat(params.value);
                }},
              {headerName:'입고', field:'inBadQty', width:120, cellStyle:{textAlign: 'right'},
                valueFormatter: (params) => {
                  return that.getNumberFormat(params.value);
                }},
              {headerName:'출고', field:'outBadQty', width:120, cellStyle:{textAlign: 'right'},
                valueFormatter: (params) => {
                  return that.getNumberFormat(params.value);
                }},
              {headerName:'출고중', field:'outingBadQty', width:120, cellStyle:{textAlign: 'right'},
                valueFormatter: (params) => {
                  return that.getNumberFormat(params.value);
                }},
              {headerName:'당월', field:'invtBadQty', width:120, cellStyle:{textAlign: 'right'},
                valueFormatter: (params) => {
                  return that.getNumberFormat(params.value);
                }}
            ]
          },
        ]
      }
    },
    $dismiss() {
      this.$emit('dismiss')
      this.$parent.close()
    },
    mainGridRefresh(idx) {
      this.mainGridApi.redrawRows();
    },
    goOpen() {
      let that = this

      this.data = [];
      this.$store.commit('loading')

      let vform = {
        companyId : this.form.companyId,
        yyMm : this.form.years + this.form.months,
        closingType : this.form.closingType, // 구분
        sortType :  '',
        page : 1,
        totalPage : 99999,
        curPage : 0,
        totalCount : 99999,
        processTime : ''
      }

      // 280 : 제품 281 : 자재
      if(parseInt(this.form.closingType) === 280) {
        vform.maker = this.form.maker // 제조사
        vform.modelGroup = (this.form.subModelGroup.length <= 0 || this.form.subModelGroup === '')  ? this.form.modelGroup : this.form.subModelGroup // 제품군
        vform.asAgentId = (this.form.subAsAgentId.length <= 0 || this.form.subAsAgentId === '')  ? (this.form.asAgentId === '' ? 0 : this.form.asAgentId) : this.form.subAsAgentId // 지역/센터
        vform.standardModelNm = this.form.standardModelNm // 대표모델
        vform.modelCd = this.form.modelCd // 모델
      } else {
        vform.itemGroup = (this.form.subModelGroup.length <= 0 || this.form.subModelGroup === '')  ? this.form.modelGroup : this.form.subModelGroup // 제품군
        vform.catId = (this.form.subAsAgentId.length <= 0 || this.form.subAsAgentId === '')  ? (this.form.asAgentId === '' ? 0 : this.form.asAgentId) : this.form.subAsAgentId // 지역/센터
        vform.maker = this.form.standardModelNm // 대표모델
        vform.itemCd = this.form.itemCd // 자재
      }

      this.$http.post(_url("/api/workMng/closingManager/list"), vform)
                .then(response => {
                    this.data = response.data
                }).finally(() => {
                    this.createMainColumnDefs()
                    this.$store.commit('finish')
      });
    },
    goClose() {

      const vSaveform = {
        companyId : this.form.companyId,
        yyMm : this.form.years + this.form.months,
        closingYn : 'Y',
        processTime : ''
      }

      this.$swal({
        type: 'warning',
        text: `마감 하시겠습니까?`,
        showCancelButton: true,
        confirmButtonText: '예',
        cancelButtonText: '아니오',
      }).then((result) => {
        if (result.value) {
          this.$store.commit('loading')
          this.$http.post("/api/workMng/closingManager/save", vSaveform)
              .then(response => {
                this.$swal({ type: 'success', text: '마감이 확정 되었습니다.' });
              }).catch((e) => {
                this.$swal({ type: 'success', text: '마감 실패했습니다.' })
              }).finally(() => {
                this.$store.commit('finish')
              });
        }
      });
    },
    async init() {
      this.$store.commit('loading');
      await this.$http.post(`/api/workMng/closingManager/init`)
          .then(response => {
            this.combos['years'] = response.data.years;
            this.combos['months'] = response.data.months;
            this.combos['closingType'] = response.data.closingType;
            this.combos['maker'] = response.data.maker;
            this.combos['modelGroup'] = response.data.modelGroup;
            this.combos['asAgentId'] = response.data.asAgentId;
          }).finally(() => {
            //this.goOpen();
            this.$store.commit('finish');
          });

      this.createMainColumnDefs();
    },
    onModelGroupChange(param){
      this.form.subModelGroup = '';
      if(param === '') this.subModelGroupShow =  false;
      else{
        this.subModelGroupShow =  true
        // 제품군
        this.$http.get(`/api/codeMng/detail`, { params: {parentId: 143} })  // 제품군
            .then(response => {
              let subData = response.data.filter(x => x.catKey === param);
              this.$http.get(`/api/codeMng/combo`, { params: {parentId: subData[0].catId} })
                  .then(response => {
                    this.combos['subModelGroup'] = response.data || []
                  });
            });
      }
    },
    onAsAgentIdChange(param){
      this.form.subAsAgentId = '';
      if(param === '') this.subAsAgentIdShow =  false;
      else{
        this.subAsAgentIdShow =  true;
        // 지역 상세
        this.$http.get(`/api/codeMng/combo/catId`, { params: {parentId: param} })
            .then(response => {
              this.combos['subAsAgentId'] = response.data || []
            });
      }
    },
    onClosingTypeChange(param){
      // 280 : 제품 281 : 자재
      if(parseInt(param) === 280){
        this.modelSearchShow = true;
        this.itemSearchShow = false;
      } else if(parseInt(param) === 281) {
        this.modelSearchShow = false
        this.itemSearchShow = true
      }
      this.defaultSetting();
      this.goOpen()
    },
    defaultSetting() {
      this.form.maker = ''
      this.form.modelGroup = ''               // 제품군
      this.form.subModelGroup = ''            // 제품군Sub
      this.form.standardModelNm = ''          // 대표모델
      this.form.modelCd = ''                  // 모델
      this.form.asAgentId = ''                // 지역/센터
      this.form.subAsAgentId = ''             // 지역/센터(sub)
      this.form.catId = ''
      this.form.itemCd = ''                   // 자재코드
      this.subModelGroupShow = false          // 제품군Sub
      this.subAsAgentIdShow = false           // 지역센터sub
    }
  },
  created() {
    this.statusBar = {
      statusPanels: [
        { statusPanel: 'agTotalRowCountComponent', align: 'right' },
      ],
    };
  },
  mounted() {
    this.form.companyId = this.$store.state.loginInfo.compCd;
  },
  computed: {
    routeName() {
      return this.$route.name
    }
  },
}
</script>

<style lang="scss" scoped>
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
</style>